import "./index.0.css";
const __script_base__ = {
  name: 'Checkbox',
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    id: {
      type: String,
      default: ''
    },
    value: {
      type: Boolean,
      required: true
    },
    readonly: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: ''
    }
  },
  computed: {
    checkboxId() {
      return this.id || `chkBox${Math.random().toString(36).substr(2)}`;
    }
  },
  methods: {
    handleChange(ev) {
      this.$emit('change', ev.target.checked);
    }
  }
};
var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticClass: "uc-checkbox-wrapper"
  }, [_c('input', {
    ref: "checkbox",
    staticClass: "uc-checkbox",
    attrs: {
      "type": "checkbox",
      "id": _vm.checkboxId,
      "disabled": _vm.readonly
    },
    domProps: {
      "checked": _vm.value
    },
    on: {
      "change": _vm.handleChange
    }
  }), _vm._v(" "), _vm.label ? _c('label', {
    staticClass: "uc-checkbox-label",
    attrs: {
      "for": _vm.checkboxId
    }
  }, [_vm._v("\n    " + _vm._s(_vm.label) + "\n  ")]) : _vm._e()]);
};
var staticRenderFns = [];
const __script__ = __script_base__;
export default Object.assign({
  render,
  staticRenderFns,
  _compiled: true
}, {
  "__file": "builtin/components/Checkbox/index.vue"
}, typeof __script__ === 'function' ? __script__.options : __script__);